import { InputProps } from "../interfaces"
import React, { FunctionComponent } from "react";
import styled from "styled-components";

const Input: FunctionComponent<InputProps> = ({
  type,
  name,
  id,
  value,
  placeholder,
  onChange,
  className,
  disabled,
}) => {
  return (
    <StyledInputWrapper className={className}>
      <input
        disabled={disabled}
        type={type}
        name={name}
        id={id}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    </StyledInputWrapper>
  );
};

const StyledInputWrapper = styled.div`
  position: relative;

  input {
    font-family: 'Metropolis',sans-serif;
    font-size: 20px;
    letter-spacing: 7px;
    text-transform: uppercase;
    width: 100%;
    height: 40px;
    border-radius: 0px;
    /*background: linear-gradient(90deg, #6f0bd9 100%, #a055fa 100%);*/
    cursor: pointer;
    text-align: center;
    outline: none;
    color: white;
    transition: 0.5s all;
    border: none;
  }

  input::placeholder {
    color: #9e9e9e;
  }
`;

export default Input;
